import { styled } from "twin.macro"
import { cycleStyles } from "../../../utils/style-helpers"

const positions = {
  base: [
    {
      x: "16%",
      mb: "-2rem",
    },
    {
      x: "-3%",
      mb: ["-3rem", 0],
    },
    {
      x: "12%",
      mb: ["-1rem", "-0.5rem"],
    },
    {
      x: "1%",
      mb: ["-2.5rem", "-0.75rem"],
    },
    {
      x: "-1rem",
      mb: ["-2.75rem", "-1.75rem"],
    },
  ],
  sm: [
    {
      mt: "-1rem",
      x: "8%",
    },
    {
      mt: ["-2rem", "-2rem"],
    },
    {
      x: "1rem",
      mt: ["-4rem", "-5rem"],
    },
    {
      mt: "-1rem",
    },
    {
      mt: "-1rem",
    },
  ],
  xl: [
    {
      x: 0,
    },
    {
      x: 0,
    },
    {
      x: "-120px",
      y: "110px",
    },
    {
      x: "-140px",
      y: "-40px",
    },
  ],
}

const WaterfallMediaWrapper = styled.div(({ index, isPortrait }) => [
  `
    position: relative;
    width: 100%;
    transition: transform .5s cubic-bezier(0.4, 0, 0.2, 1), box-shadow .5s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(var(--ft-x, 0)) translateY(var(--ft-y, 0)) scale(var(--ft-scale, 1));
    margin-top: var(--ft-mt, 0);
    margin-bottom: var(--ft-mb, 0);

    ${cycleStyles(positions.base, index, isPortrait)}

    @media (min-width: 640px) {
      margin-bottom: 0;
      ${cycleStyles(positions.sm, index, isPortrait)}
    }

    @media (min-width: 1280px) {
      ${cycleStyles(positions.xl, index, isPortrait)}
    }

    &:hover {
      --ft-scale: 1.05;
      box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)
    }

    img {
      border-radius: .25rem;
    }

  `,
])

export default WaterfallMediaWrapper
